// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3IfwM","content":"ManualTimeModal_content__3TrMC"};